<!--
* @FileDescription: 管理后台侧边栏
* @Author: Rocky
* @Date: 2020-12-25
* @LastEditors: Rocky
* @LastEditTime: 2020-12-25
-->
<template>
  <div id="app-aside">
    <div class="app-aside-control">
      <i :class="controlIcon" @click="toggleAside">{{ controlText }}</i>
    </div>
    <el-menu :default-active="currentIndex" :collapse="controlCollapse">
      <template v-for="(item, i) in sidebarItems">
        <span v-if="item.title" class="app-aside-title" :key="i">{{ item.text }}</span>
        <el-submenu v-if="item.trees && item.trees.length > 0" :index="item.index" :key="i">
          <template slot="title"><i :class="item.icon"></i><span>{{ item.text }}</span></template>
          <el-menu-item-group>
            <el-menu-item v-for="subitem in item.trees" :key="subitem.index" :index="subitem.index"
            :data-path="subitem.path" @click="goMain">{{ subitem.text }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item v-if="item.trees && item.trees.length <= 0" :data-path="item.path" @click="goMain" :index="item.index" :key="i">
          <i :class="item.icon"></i><span>{{ item.text }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'app-aside',
  data () {
    return {
      controlIcon: 'el-icon-caret-left', // 右箭头 / 左箭头
      controlText: '收起', // 展开 / 收起
      controlCollapse: false, // 侧边栏展开状态
      currentIndex: '1', // 当前高亮 index
      sidebarItems: [
        { index: '1', path: '/', text: '数据统计', icon: 'el-icon-s-data', trees: [] },
        { title: true, text: '商城管理' },
        { index: '2', path: '/settings', text: '客服配置', icon: 'el-icon-s-operation', trees: [] },
        { index: '3', path: '/sliders', text: '幻灯片', icon: 'el-icon-picture', trees: [] },
        { index: '5', path: '/brands', text: '品牌', icon: 'el-icon-s-flag', trees: [] },
        { index: '6', path: '/countries', text: '原产国信息', icon: 'el-icon-info', trees: [] },
        { title: true, text: '分类管理' },
        { index: '4', path: '/categories', text: '国家/城市馆', icon: 'el-icon-s-grid', trees: [] },
        { index: '30', path: '/tradeIndustry', text: '贸易/行业通', icon: 'el-icon-chat-line-square', trees: [] },
        { index: '31', path: '/industryInformation', text: '鑫豆行业资讯', icon: 'el-icon-news', trees: [] },
        { title: true, text: '资讯管理' },
        { index: '26', path: '/InformationCates', text: '资讯分类', icon: 'el-icon-reading', trees: [] },
        { index: '27', path: '/Information', text: '资讯详情', icon: 'el-icon-notebook-2', trees: [] },
        { title: true, text: '活动优惠' },
        // { index: '14', path: '/singleGood', text: '单个商品', icon: 'el-icon-star-on', trees: [] },
        // { index: '14', path: '/special', text: '每日秒杀', icon: 'el-icon-star-on', trees: [] },
        { index: '13', path: '/activity', text: '专场活动', icon: 'el-icon-present', trees: [] },
        { index: '16', path: '/voucher', text: '优惠券', icon: 'el-icon-discount', trees: [] },
        { title: true, text: '运费' },
        // { index: '17', path: '/FreightTemplate', text: '运费模板', icon: 'el-icon-tickets', trees: [] },
        { index: '18', path: '/restrictedArea', text: '限发区域', icon: 'el-icon-map-location', trees: [] },
        { title: true, text: '商品' },
        { index: '7', path: '/goods', text: '商品管理', icon: 'el-icon-s-goods', trees: [] },
        { index: '8', path: '/records', text: '备案信息', icon: 'el-icon-s-ticket', trees: [] },
        { index: '9', path: '/warehouses', text: '仓库配置', icon: 'el-icon-s-home', trees: [] },
        { index: '15', path: '/group', text: '组合管理', icon: 'el-icon-menu', trees: [] },
        { title: true, text: '订单' },
        {
          index: '10',
          path: '#',
          text: '订单管理',
          icon: 'el-icon-s-order',
          trees: [
            { index: '10-4', path: '/ordersPayment', text: '待申报' },
            { index: '10-5', path: '/ordersCart', text: '待清关' },
            { index: '10-6', path: '/ordersFinish', text: '已清关' },
            { index: '10-7', path: '/ordersFail', text: '清关失败' },
            { index: '10-8', path: '/OrdersWaitingCross', text: '待发货-跨境' },
            { index: '10-1', path: '/ordersWaiting', text: '待发货-自营' },
            { index: '10-2', path: '/ordersSend', text: '已发货' },
            { index: '10-3', path: '/ordersAll', text: '全部订单' }
          ]
        },
        { title: true, text: '拼团' },
        {
          index: '16',
          path: '#',
          text: '订单管理',
          icon: 'el-icon-document',
          trees: [
            { index: '16-4', path: '/pinOrdersPayment', text: '待申报' },
            { index: '16-5', path: '/pinOrdersCart', text: '待清关' },
            { index: '16-6', path: '/pinOrdersFinish', text: '已清关' },
            { index: '16-7', path: '/pinOrdersFail', text: '清关失败' },
            { index: '16-8', path: '/pinOrdersFailure', text: '拼团失败' },
            { index: '16-1', path: '/pinOrdersWaiting', text: '待发货' },
            { index: '16-2', path: '/pinOrdersSend', text: '已发货' },
            { index: '16-3', path: '/pinOrdersAll', text: '全部订单' }
          ]
        },
        { title: true, text: '用户' },
        { index: '11', path: '/users', text: '用户管理', icon: 'el-icon-user-solid', trees: [] },
        {
          index: '12',
          path: '#',
          text: '售后',
          icon: 'el-icon-phone',
          trees: [
            { index: '12-1', path: '/serviceInit', text: '待处理' },
            { index: '12-2', path: '/serviceWaiting', text: '待邮寄' },
            { index: '12-3', path: '/serviceSend', text: '已邮寄' },
            { index: '12-4', path: '/serviceFinish', text: '已完成' },
            { index: '12-5', path: '/serviceReject', text: '已驳回' }
          ]
        },
        { title: true, text: '导购端' },
        {
          index: '20',
          path: '/branches',
          text: '门店管理',
          icon: 'el-icon-s-shop',
          trees: [
          ]
        },
        {
          index: '28',
          path: '/salesOverview',
          text: '门店概况',
          icon: 'el-icon-monitor',
          trees: [
          ]
        },
        {
          index: '21',
          path: '/personnel',
          text: '人员一览',
          icon: 'el-icon-user-solid',
          trees: [
          ]
        },
        {
          index: '22',
          path: '#',
          text: '佣金管理',
          icon: 'el-icon-money',
          trees: [
            { index: '22-1', path: '/checkPending', text: '分销审核' },
            { index: '22-2', path: '/taskCheckPending', text: '任务审核' },
            { index: '22-3', path: '/commission', text: '财务室' },
            { index: '22-4', path: '/cashWithdrawn', text: '佣金一览' }
          ]
        },
        {
          index: '23',
          path: '#',
          text: '任务管理',
          icon: 'el-icon-document',
          trees: [
            { index: '23-1', path: '/task', text: '模板管理' }
          ]
        },
        // {
        //   index: '24',
        //   path: '#',
        //   text: '核券管理',
        //   icon: 'el-icon-document',
        //   trees: [
        //     { index: '24-1', path: '/clerkCouppon', text: '店员管理' },
        //     { index: '24-2', path: '/bindCouppon', text: '绑定优惠券' },
        //     { index: '24-3', path: '/recordCouppon', text: '核券纪录' }
        //   ]
        // },
        { title: true, text: '工具' },
        { index: '28', path: '/appletCode', text: '生成小程序码', icon: 'el-icon-full-screen', trees: [] }
      ]
    }
  },
  methods: {
    /**
     * 通过路由检查当前高亮链接
     */
    highlightSidebar () {
      let that = this
      let currentLocation = window.location.href.split('#')[1]
      let highlightIndex = '1'
      for (let i = 0; i < that.sidebarItems.length; i++) {
        const lv1 = that.sidebarItems[i]
        if (lv1.path && lv1.path === currentLocation) highlightIndex = lv1.index
        if (lv1.trees) {
          for (let j = 0; j < lv1.trees.length; j++) {
            const lv2 = lv1.trees[j]
            if (lv2.path === currentLocation) highlightIndex = lv2.index
          }
        }
      }
      that.currentIndex = highlightIndex
    },
    /**
     * 跳转到 Main 中对应链接
     */
    goMain (e) {
      let that = this
      let linkPath = e.$el.dataset.path
      if (linkPath !== this.$route.path) {
        that.$router.replace({
          path: e.$el.dataset.path,
          params: {}
        })
      }
    },
    /**
     * 收展侧边栏
     */
    toggleAside () {
      let that = this
      that.controlCollapse = !that.controlCollapse
      that.controlText = that.controlCollapse ? '' : '收起'
      that.controlIcon = that.controlCollapse ? 'el-icon-caret-right' : 'el-icon-caret-left'
      that.$emit('toggleAside', that.controlCollapse)
    }
  },
  mounted () {
    this.highlightSidebar()
  }
}
</script>

<style>
.el-menu {
  background-color: #f1f1f1;
}
.el-submenu__title,
.el-menu-item {
  font-size: 12px;
  height: 50px;
  line-height: 50px;
}
.el-submenu__title:hover,
.el-menu-item:focus, .el-menu-item:hover,
.el-menu-item:hover i,
.el-menu-item.is-active {
  color: #626c79;
  background-color: #fafafa;
}
.app-aside-control > i {
  font-size: 11px;
  font-weight: bold;
  padding: 10px;
  color: #bebebe;
  cursor: pointer;
}
.app-aside-control > i:hover {
  color: #343A40;
}
.app-aside-title {
  padding-left: 10px;
  margin: 8px 0;
  display: block;
  color: #454545;
}
</style>



// WEBPACK FOOTER //
// src/components/frame/Aside.vue